import styled from 'styled-components';
import { ICON_SELECTOR, IconSize, SpinnerIcon } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  ${ICON_SELECTOR} {
    color: ${colors.iconOnInvertedStrong};
  }
`;

export const ModalLoader = () => (
  <Wrapper>
    <SpinnerIcon iconSize={64 as IconSize} />
  </Wrapper>
);
